import { BudgetForm } from "./BudgetForm";

export class OurWorkBudgetForm extends BudgetForm {
  our_work_budget_category_id: string;

  constructor(
    args: ConstructorParameters<typeof BudgetForm>[0] & {
      our_work_budget_category_id: string;
    },
  ) {
    super(args);
    this.our_work_budget_category_id = args.our_work_budget_category_id;
  }

  serialize() {
    return {
      our_work_budget_category_id: this.our_work_budget_category_id,
      ...super.serialize(),
    };
  }
}
